import { useCallback, useContext } from "react";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { IUpdateTravellerParams } from "../domain";
import { apiServiceContext } from "../../api-service-context";
import { EntityType } from "../query-keys";

export const useUpdateTravellers = (options?: UseMutationOptions<any, any, IUpdateTravellerParams>) => {
  const { travellersApiService } = useContext(apiServiceContext);
  const queryClient = useQueryClient();

  const mutationFn = useCallback(
    (payload: IUpdateTravellerParams) =>
      travellersApiService.createCancellableRequest((cancelToken) =>
        travellersApiService.updateTraveller(payload, cancelToken)
      ),
    [travellersApiService]
  );

  const mutation = useMutation<any, any, IUpdateTravellerParams>(mutationFn, {
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries(EntityType.USER_TRAVELLERS);
      options?.onSuccess?.(...args);
    },
  });

  return mutation;
};
